import Fetch from "../../utils/Fetch"

export default {
    namespaced: true,
    state: {
        userLocation: {
            lat: null,
            lon: null
        },
        userCity: null,
        citiesList: JSON.parse(localStorage.getItem('cities-list')) || [],
    },
    mutations: {
        setUserLocation(state, {lat, lon}) {
            if (!lat || !lon) return
            state.userLocation.lat = lat
            state.userLocation.lon = lon
        },
        setUserCity(state, city) {
            if (!city) return
            state.userCity = city
        },
        setCitiesList(state, data) {
            if (!data) return
            state.citiesList = data
            localStorage.setItem('cities-list', JSON.stringify(data))
        }
    },
    actions: {
        async loadUserLocation({commit, dispatch}) {
            let response = await Fetch('user/')
            if (response.success) {
                if (response.data.location) {
                    commit('setUserLocation', {
                        lat: response.data.location.lat,
                        lon: response.data.location.lon
                    })
                    dispatch('loadClosestCity')
                }
            }
        },
        async loadClosestCity({commit, state}) {
            let response = await Fetch(`pawns/cities/closest/?lat=${state.userLocation.lat}&lon=${state.userLocation.lon}`)
            if (response.success) {
                commit('setUserCity', response.data)
            }
        },
        async confirmUserCity({commit, state}) {
            if (!state.userCity) return
            let response = await Fetch(`service/cities/${state.userCity.id}/set/`, {
                method: 'GET'
            })
            if (response.success) {
                commit('setUserCity', response.data)
            }
        },       
        async loadCitiesList({commit, state}) {
            if (state.citiesList.length) return
            let response = await Fetch(`service/cities/`)
            if (response.success) {
                commit('setCitiesList', response.data)
                
            }
        }
    },
    getters: {
        getUserLocation: state => state.userLocation,
        getUserCity: state => state.userCity,
        getCitiesList: state => state.citiesList,
        isCourierAvailable: (state) => id => {
            if (!id) return false

            let cityData = state.citiesList.find(i => i.id === id) || null
            if (cityData) {  
                return cityData.available_courier
            }
            return false
        },
        getCityIdByName: (state) => name => {
            return state.citiesList.find(i => i.name.toLowerCase() === name.toLowerCase()).id;
        }
    }
}